<mat-progress-bar *ngIf="!state.searchResults || this.state.loadingData" mode="indeterminate"></mat-progress-bar>
<app-toolbar *ngIf="state.searchResults"></app-toolbar>


<app-facet *ngIf="state.searchResults"></app-facet>
<div class="app-result-wrapper">
  <app-result-table></app-result-table>
</div>
